export const CHANGE_REPEATS = "CHANGE_REPEATS";

export default function changeRepeats(section, questionId, optionValue, repeatId, cultureCode) {
  return {
    type: CHANGE_REPEATS,
    payload: { section, questionId, optionValue, repeatId, cultureCode },
  };
}
